import { takeLatest, put, call, select } from 'redux-saga/effects'

import { indicateProgress } from 'api'
import * as auth from 'auth'

import * as constants from './constants'
import * as actions from './actions'
import * as selectors from './selectors'
import * as grsApi from './grsApi'

function getBaselineFromUser(user) {
    const enabled = Boolean(user?.onDemandOptIn)
    const selectedVehicleIds = (user?.vehicles || []).filter(v => v?.onDemandOptIn).map(v => v.id)
    const selectedCardId = (user?.creditCards || []).find(c => c?.onDemandOptIn)?.id ?? null
    return { enabled, selectedVehicleIds, selectedCardId }
}

function* initSaga() {
    const user = yield select(auth.selectors.userSelector)
    const baseline = getBaselineFromUser(user)
    yield put(actions.setOnDemandParkingBaseline(baseline))
}

function* activateSaga() {
    try {
        const user = yield select(auth.selectors.userSelector)
        const token = yield select(auth.selectors.tokenSelector)
        const details = yield select(auth.selectors.userDetailsSelector)
        if (!user || !token) return

        const selectedVehicleIds = yield select(selectors.draftSelectedVehicleIdsSelector)
        const selectedCardId = yield select(selectors.draftSelectedCardIdSelector)

        if (!selectedVehicleIds.length || selectedCardId === null) return

        const normalized = yield call(indicateProgress, ['activateOnDemandParking'], grsApi.updateOnDemandParking, {
            token,
            details,
            vehicles: user.vehicles || [],
            creditCards: user.creditCards || [],
            enable: true,
            selectedVehicleIds,
            selectedCardId,
        })

        yield put(auth.actions.setAuthenticatedUser(normalized))
        yield put(actions.initOnDemandParking())
    } catch (error) {}
}

function* saveChangesSaga() {
    try {
        const user = yield select(auth.selectors.userSelector)
        const token = yield select(auth.selectors.tokenSelector)
        const details = yield select(auth.selectors.userDetailsSelector)
        const isActivated = yield select(selectors.isOnDemandParkingActivatedSelector)
        if (!user || !token || !isActivated) return

        const canSave = yield select(selectors.canSaveSelector)
        if (!canSave) return

        const draftEnabled = yield select(selectors.draftEnabledSelector)
        const selectedVehicleIds = yield select(selectors.draftSelectedVehicleIdsSelector)
        const selectedCardId = yield select(selectors.draftSelectedCardIdSelector)

        const normalized = yield call(indicateProgress, ['saveOnDemandParking'], grsApi.updateOnDemandParking, {
            token,
            details,
            vehicles: user.vehicles || [],
            creditCards: user.creditCards || [],
            enable: draftEnabled,
            selectedVehicleIds,
            selectedCardId,
        })

        yield put(auth.actions.setAuthenticatedUser(normalized))
        yield put(actions.initOnDemandParking())
    } catch (error) {}
}

export default function* rootSaga() {
    yield takeLatest(constants.INIT_ON_DEMAND_PARKING, initSaga)
    yield takeLatest(constants.ACTIVATE_ON_DEMAND_REQUEST, activateSaga)
    yield takeLatest(constants.SAVE_ON_DEMAND_CHANGES_REQUEST, saveChangesSaga)
}
